import React, { Component } from "react";
import {
  Grid,
  Paper,
  TextField,
  Switch,
  Typography,
  MenuItem,
  Dialog,
  CircularProgress,
  Button
} from "@material-ui/core";
import styles from "../../styles";
import { withStyles } from "@material-ui/core/styles";
import UploadImage from "../UploadImage";

import _ from "lodash";
import validate from "validate.js";
import { imageSchema, settingsSchema } from "./schema";

import { connect } from "react-redux";
import { pushMessage } from "../../../../redux/actions/commonActions";
import { updateChatbotSettings } from "../../../../redux/actions/chatbotActions";

const initialValuesState = {
  botName: "",
  welcomeMessage: "",
  examplePhraseA: "",
  examplePhraseB: "",
  examplePhraseC: "",
  chatImage: "",
  chatImageLink: "",
  chatIcon: "",
  bigChatIcon: "",
  voiceEnabled: true,
  bubbles: false,
  continuousListening: false,
  imageName: {},
  domain: ""
};

class SettingsForm extends Component {
  constructor(props) {
    super(props);
    const valid = _.isEmpty(props.data) ? false : true;
    const values = { ...initialValuesState };
    if (!_.isEmpty(props.data)) {
      values["botName"] = _.get(props.data, "config.botName", "");
      values["welcomeMessage"] = _.get(props.data, "config.welcomeMessage", "");
      values["examplePhraseA"] = _.get(props.data, "config.examplePhrases[0]", "");
      values["examplePhraseB"] = _.get(props.data, "config.examplePhrases[1]", "");
      values["examplePhraseC"] = _.get(props.data, "config.examplePhrases[2]", "");
      values["chatImage"] = _.get(props.data, "config.chatImage", "");
      values["chatImageLink"] = _.get(props.data, "config.chatImageLink", "");
      values["chatIcon"] = _.get(props.data, "config.chatIcon", "");
      values["bigChatIcon"] = _.get(props.data, "config.bigChatIcon", false);
      values["voiceEnabled"] = _.get(props.data, "config.voiceEnabled", true);
      values["bubbles"] = _.get(props.data, "config.bubbles", false);
      values["continuousListening"] = _.get(props.data, "config.continuousListening", false);
/*       values["imageName"] = _.get(props.data, "config.imageName", ""); */
      values["desktopBottom"] = _.get(props.data, "config.position.desktopBottom", 0);
      values["desktopRight"] = _.get(props.data, "config.position.desktopRight", 0);
      values["mobileBottom"] = _.get(props.data, "config.position.mobileBottom", 0);
      values["mobileRight"] = _.get(props.data, "config.position.mobileRight", 0);
      values["iconCircle"] = _.get(props.data, "config.color.iconCircle", "#b59a6d");
      
      const domainList = _.get(props.data, "allowed_domains", []);
      if (_.isEmpty(domainList)) values["domain"] = "";
      else {
        let domain = "";
        for (let i = 0; i < domainList.length; i++) {
          domain += domainList[i];
          if (i < domainList.length - 1) domain += ", ";
        }
        values["domain"] = domain;
      }
      values["continuousListening"] = _.get(props.data, "config.continuousListening", false);
    }

    this.state = {
      webImage: {},
      open: false,
      uploadMethod: "",
      isLoading: false,
      modalType: null,
      values: {
        ...values
      },
      touched: {
        botName: valid,
        welcomeMessage: valid,
        examplePhraseA: valid,
        examplePhraseB: valid,
        examplePhraseC: valid,
        chatImage: valid,
        chatImageLink: valid,
        chatIcon: valid,
        bigChatIcon: valid,
        domain: valid,
        desktopRight: valid,
        desktopBottom: valid,
        mobileRight: valid,
        mobileBottom: valid
      },
      errors: {
        botName: null,
        welcomeMessage: null,
        examplePhraseA: null,
        examplePhraseB: null,
        examplePhraseC: null,
        chatImageLink: null,
        chatIcon: valid,
        bigChatIcon: valid,
        domain: null,
        desktopRight: valid,
        desktopBottom: valid,
        mobileRight: valid,
        mobileBottom: valid
      },
      imageError: {
        chatImage: null,
        chatIcon: null
      },
      formValid: valid,
      imageValid: valid,
      changed: false
    };
  }
  //TODO: NAPRAVI VALIDACIJU
  componentDidMount() {
    this.mounted = true;
    this.validateAllFields();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  validateAllFields = () => {
    let validationState = { touched: this.state.touched };
    let validationStateErrors = {};
    let fieldValidationNewState;

    for (const field of Object.keys(this.state.values)) {
      fieldValidationNewState = this.validateForm(field, true);
      validationStateErrors = { ...validationStateErrors, ...fieldValidationNewState.errors };
      validationState.touched[field] = fieldValidationNewState.touched[field];
    }

    validationState.errors = validationStateErrors;
    validationState.formValid = !validationStateErrors;

    this.setState(validationState);
  };

  validateForm = (field, returnNewStateObject = false) => {
    const {
      values: {
        botName,
        welcomeMessage,
        examplePhraseA,
        examplePhraseB,
        examplePhraseC,
        chatImageLink,
        bigChatIcon,
        chatIcon,
        domain,
        desktopRight,
        desktopBottom,
        mobileRight,
        mobileBottom
      }
    } = this.state;

    const newState = { ...this.state };
    const errors = validate(
      {
        botName,
        welcomeMessage,
        examplePhraseA,
        examplePhraseB,
        examplePhraseC,
        chatImageLink,
        bigChatIcon,
        chatIcon,
        domain,
        desktopRight,
        desktopBottom,
        mobileRight,
        mobileBottom
      },
      settingsSchema
    );

    newState.errors = errors || {};
    newState.touched[field] = true;
    newState.formValid = errors ? false : true;
    newState.changed = true;

    if (returnNewStateObject) {
      return newState;
    }

    this.setState(newState);
  };

  validateFormDebounced = _.debounce(this.validateForm, 200);

  handleInput = (field, value) => {
    const newState = { ...this.state };
    newState.values[field] = value;
    newState.changed = true;
    if (_.includes(["voiceEnabled", "bubbles", "continuousListening"], field)) {
      this.setState(newState);
    }else if(_.includes("bigChatIcon", field)){
      if(value === false){
        newState.values['chatIcon'] = "";
      }
    } else if (field === "chatImage" || field==="chatIcon") {
      newState.webImage[field] = true;
      newState.values["imageName"] = "";
      this.setState(newState, this.validateImage(value));
    } 
      this.setState(newState, this.validateFormDebounced(field));

    var set = {
      botName: newState.values["botName"],
      welcomeMessage: newState.values["welcomeMessage"],
      examplePhrases: [
        newState.values["examplePhraseA"],
        newState.values["examplePhraseB"],
        newState.values["examplePhraseC"]
      ],
      chatImage: newState.values["chatImage"],
      chatImageLink: newState.values["chatImageLink"],
      chatIcon: newState.values["chatIcon"],
      bigChatIcon: newState.values["bigChatIcon"],
      voiceEnabled: newState.values["voiceEnabled"],
      bubbles: newState.values["bubbles"],
      continuousListening: newState.values["continuousListening"],
      imageName: newState.values["imageName"],
      position: {
        desktopBottom: newState.values["desktopBottom"],
        desktopRight: newState.values["desktopRight"],
        mobileBottom: newState.values["mobileBottom"],
        mobileRight: newState.values["mobileRight"]
      }
    };
    this.props.updateSetting(set);
  };

  validateImage = _.debounce(image => {
    const newState = { ...this.state };
    const errors = validate({ image }, imageSchema);
    newState.imageError = errors || {};
    newState.touched[this.state.modalType] = true;
    newState.imageValid = errors ? false : true;
    newState.changed = true;
    this.setState(newState);
  }, 200);

  handleImageUpload = event => {
    let file = event.target.files[0];
    if (file) {
      let img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (file.size < 1000000) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            const newState = { ...this.state };
            newState.webImage[this.state.modalType] = false;
            newState.values[this.state.modalType] = reader.result;
            newState.values.imageName[this.state.modalType] = file.name;
            newState.open = false;
            newState.uploadMethod = "";
            newState.changed = true;
            this.setState(newState, () => {
              this.validateImage(file.name);
              this.validateFormDebounced();
            });
          };
        } else {
          this.props.pushMessage({
            message:
              "The image you uploaded is larger than the 1MB filesize limit. Please reduce the filesize and try again.",
            type: "warning"
          });
        }
      };
    }
  };

  handleSelect = (value, type) => {
    var newState = { ...this.state };
    newState["uploadMethod"] = value;
    newState["modalType"] = type;
    newState["open"] = true;
/*     newState.values[type] = ""; */
    newState.imageError[type] = null;
    newState.touched["chatImage"] = false;
    newState["imageValid"] = false;
    this.setState(newState);
  };

  handleClose = () => {
    this.setState({ uploadMethod: "", open: false, [this.state.modalType]:"" });
  };

  handleSave = async e => {
    e.preventDefault();
    this.setState({ isLoading: true });
    const {
      webImage,
      values: {
        botName,
        welcomeMessage,
        examplePhraseA,
        examplePhraseB,
        examplePhraseC,
        chatImage,
        chatImageLink,
        bigChatIcon,
        chatIcon,
        voiceEnabled,
        bubbles,
        continuousListening,
        imageName,
        domain,
        desktopBottom,
        desktopRight,
        mobileBottom,
        mobileRight
      }
    } = this.state;
    const allowedDomains = domain.replace(/\s/g, "").split(",");
    console.log(this.state);
    await this.props
      .updateChatbotSettings({
        GUID: _.get(this.props, "data.GUID"),
        botName,
        welcomeMessage,
        examplePhrases: [examplePhraseA, examplePhraseB, examplePhraseC],
        chatImage,
        chatImageNew: webImage['chatImage'] === false ? chatImage : "",
        imageURL: webImage['chatImage'] ? chatImage : "",
        chatImageLink,
        voiceEnabled,
        bubbles,
        bigChatIcon,
        chatImage,
        chatIconNew: webImage['chatIcon'] === false ? chatIcon : "",
        iconURL: webImage['chatIcon'] ? chatIcon : "", 
        chatIcon,
        continuousListening, 
        imageName: imageName['chatImage']?imageName['chatImage']:"",
        iconName: imageName['chatIcon']?imageName['chatIcon']:"",
        allowedDomains,
        desktopBottom,
        desktopRight,
        mobileBottom,
        mobileRight
      })
      .then(() => {
        if (this.mounted) this.setState({ isLoading: false });
      });
  };

  render() {
    const { classes, administrator } = this.props;
    const {
      open,
      isLoading,
      uploadMethod,
      values,
      errors,
      touched,
      imageError,
      formValid,
      imageValid,
      changed,
      modalType
    } = this.state;
    const displayBotNameError = touched.botName && errors.botName;
    const displayWelcomeMessageError = touched.welcomeMessage && errors.welcomeMessage;
    const displayExamplePhraseAError = touched.examplePhraseA && errors.examplePhraseA;
    const displayExamplePhraseBError = touched.examplePhraseB && errors.examplePhraseB;
    const displayExamplePhraseCError = touched.examplePhraseC && errors.examplePhraseC;
    const displayChatImageLinkError = touched.chatImageLink && errors.chatImageLink;
    const displayDomainListError = touched.domain && errors.domain;
    const displayChatImageError = touched.chatImage && imageError.image;
    const displayDesktopBottomError = touched.desktopBottom && errors.desktopBottom;
    const displayDesktopRightError = touched.desktopRight && errors.desktopRight;
    const displayMobileBottomError = touched.mobileBottom && errors.mobileBottom;
    const displayMobileRightError = touched.mobileRight && errors.mobileRight;

    return (
      <React.Fragment>
        <Dialog open={open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
          <UploadImage
            handleChange={this.handleInput}
            handleImageUpload={this.handleImageUpload}
            uploadMethod={uploadMethod}
            handleClose={this.handleClose}
            administrator={administrator}
            chatImage={modalType==="chatIcon"?values.chatIcon:values.chatImage}
            classes={classes}
            type={modalType}
          />
        </Dialog>
        <Paper className={classes.row} elevation={0}>
          <form onSubmit={this.handleSave}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <TextField
                  id="bot_name"
                  className={classes.textfield}
                  variant="outlined"
                  label="Bot Name"
                  onChange={event => this.handleInput("botName", event.target.value)}
                  value={values.botName}
                  inputProps={{ maxLength: 30 }}
                />
                {displayBotNameError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.botName[0]}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="welcome_message"
                  className={classes.textfield}
                  variant="outlined"
                  label="Welcome Message"
                  onChange={event => this.handleInput("welcomeMessage", event.target.value)}
                  value={values.welcomeMessage}
                  multiline
                  rowsMax={7}
                  inputProps={{ maxLength: 1000 }}
                />
                {displayWelcomeMessageError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.welcomeMessage[0]}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="example_phrase_a"
                  className={classes.textfield}
                  variant="outlined"
                  label="Example Phrase A"
                  onChange={event => this.handleInput("examplePhraseA", event.target.value)}
                  value={values.examplePhraseA}
                  inputProps={{ maxLength: 100 }}
                />
                {displayExamplePhraseAError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.examplePhraseA[0]}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="example_phrase_b"
                  className={classes.textfield}
                  variant="outlined"
                  label="Example Phrase B"
                  onChange={event => this.handleInput("examplePhraseB", event.target.value)}
                  value={values.examplePhraseB}
                  inputProps={{ maxLength: 100 }}
                />
                {displayExamplePhraseBError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.examplePhraseB[0]}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="example_phrase_c"
                  className={classes.textfield}
                  variant="outlined"
                  label="Example Phrase C"
                  onChange={event => this.handleInput("examplePhraseC", event.target.value)}
                  value={values.examplePhraseC}
                  inputProps={{ maxLength: 100 }}
                />
                {displayExamplePhraseCError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.examplePhraseC[0]}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  className={classes.formControl}
                  id="outlined-select-currency"
                  select
                  label="Set Different Chat Image"
                  value=""
                  onChange={event => this.handleSelect(event.target.value, "chatImage")}
                  variant="outlined"
                  helperText="Choose upload method"
                >
                  <MenuItem id="upload" value="local">
                    Upload Chat Image
                  </MenuItem>
                  <MenuItem id="upload_via_web" value="web">
                    Paste Image URL
                  </MenuItem>
                </TextField>
                {values.chatImage ? <img className={classes.imgPreview} src={`${values.chatImage}`} /> : null}
               {/*  {displayChatImageError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {imageError.chatImage[0]}
                  </Typography>
                )} */}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="chat_image_link"
                  className={classes.textfield}
                  variant="outlined"
                  label="Chat Image Link"
                  onChange={event => this.handleInput("chatImageLink", event.target.value)}
                  value={values.chatImageLink}
                  inputProps={{ maxLength: 200 }}
                />
                {displayChatImageLinkError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.chatImageLink[0]}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  helperText={'Enter a domain or a list of domains separated by a comma " , "'}
                  id="allowed_domains"
                  className={classes.textfield}
                  variant="outlined"
                  label="Allowed Domains"
                  onChange={event => this.handleInput("domain", event.target.value)}
                  value={values.domain}
                  inputProps={{ maxLength: 300 }}
                />
                {displayDomainListError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.domain[0]}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={4} className={classes.sliderText}>
                <Typography variant="body1">Voice Enabled:</Typography>
              </Grid>
              <Grid item xs={8}>
                <div className={classes.actionsIcon}>
                  <span>
                    <Switch
                      checked={values.voiceEnabled}
                      onClick={() => this.handleInput("voiceEnabled", !values.voiceEnabled)}
                    />
                  </span>
                </div>
              </Grid>
              <Grid item xs={4} className={classes.sliderText}>
                <Typography variant="body1">Bubbles:</Typography>
              </Grid>
              <Grid item xs={8}>
                <div className={classes.actionsIcon}>
                  <span>
                    <Switch checked={values.bubbles} onClick={() => this.handleInput("bubbles", !values.bubbles)} />
                  </span>
                </div>
              </Grid>
              <Grid item xs={4} className={classes.sliderText}>
                <Typography variant="body1">Continuous Listening:</Typography>
              </Grid>
              <Grid item xs={8}>
                <div className={classes.actionsIcon}>
                  <span>
                    <Switch
                      checked={values.continuousListening}
                      onClick={() => this.handleInput("continuousListening", !values.continuousListening)}
                    />
                  </span>
                </div>
              </Grid>
              <Grid item xs={4} className={classes.sliderText}>
                <Typography variant="body1">Custom Chat Circle Icon:</Typography>
              </Grid>
              <Grid item xs={8}>
                <div className={classes.actionsIcon}>
                  <span>
                    <Switch checked={values.bigChatIcon} onClick={() => this.handleInput("bigChatIcon", !values.bigChatIcon)} />
                  </span>
                </div>
              </Grid>
                {values.bigChatIcon&&
              <Grid style={{display: 'flex'}} item xs={6}>
               <TextField
                  className={classes.formControl}
                  id="outlined-select-currency"
                  select
                  label="Set Chat Circle Icon"
                  value=""
                  onChange={event => this.handleSelect(event.target.value, "chatIcon")}
                  variant="outlined"
                  helperText="Choose upload method"
                >
                  <MenuItem id="upload" value="local">
                    Upload Image
                  </MenuItem>
                  <MenuItem id="upload_via_web" value="web">
                    Paste Image URL
                  </MenuItem>
                </TextField>
                {values.chatIcon &&
                <div style={{background: values.iconCircle}} className={classes.chatCircle} >
                  <img className={classes.chatCircleIcon} src={`${values.chatIcon}`} /> 
                </div>}
               {/*  {displayChatImageError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {imageError.chatIcon[0]}
                  </Typography>
                )} */}
              </Grid>
                }
              <Grid item mt={20} xs={12}>
                <Typography variant="h5">Chatbot Position Desktop:</Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  label="Distance from Right (px)"
                  variant="outlined"
                  name="Right"
                  value={values.desktopRight}
                  onChange={event => this.handleInput("desktopRight", event.target.value)}
                />
                {displayDesktopRightError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.desktopRight[0]}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  label="Distance from Bottom (px)"
                  variant="outlined"
                  name="Bottom"
                  value={values.desktopBottom}
                  inputProps={{ maxLength: 6 }}
                  onChange={event => this.handleInput("desktopBottom", event.target.value)}
                />
                {displayDesktopBottomError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.desktopBottom[0]}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1">Chatbot Position Mobile:</Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  label="Distance from Right (px)"
                  variant="outlined"
                  name="Right"
                  value={values.mobileRight}
                  onChange={event => this.handleInput("mobileRight", event.target.value)}
                />
                {displayMobileRightError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.mobileRight[0]}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  label="Distance from Bottom (px)"
                  variant="outlined"
                  name="Bottom"
                  value={values.mobileBottom}
                  inputProps={{ maxLength: 6 }}
                  onChange={event => this.handleInput("mobileBottom", event.target.value)}
                />
                {displayMobileBottomError && (
                  <Typography className={classes.fieldError} variant="body2">
                    {errors.mobileBottom[0]}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                {isLoading ? (
                  <CircularProgress className={classes.progress} />
                ) : (
                  <Button
                    className={classes.saveButton}
                    color="primary"
                    disabled={!formValid || !imageValid || !changed}
                    size="large"
                    variant="contained"
                    type="submit"
                  >
                    Save Settings
                  </Button>
                )}
              </Grid>
            </Grid>
          </form>
        </Paper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return{
  administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator"
}};

SettingsForm = connect(mapStateToProps, { pushMessage, updateChatbotSettings })(SettingsForm);

export default withStyles(styles)(SettingsForm);
